import { Pipe, PipeTransform, Injectable, inject } from '@angular/core';
import AngularHelperService from '../services/angular-helper.service';

@Pipe({ name: 'capitalize', standalone: true })
@Injectable({providedIn: 'root'})
export class CapitalizePipe implements PipeTransform {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	transform(input) {
		return (this.angularHelperService.isString(input) && input.length > 0)
			? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase()
			: input;
	}
	
}